<template>
  <div class="couponItem">
    <div ref="printCoupon" class="printCoupon">
      <div v-show="hasImage" class="image"><img :src="payload.image" alt=""></div>
      <div class="titleBox">
        <pre class="title" v-if="payload.text1[lang].trim().length > 0">{{payload.text1[lang]}}</pre>
        <pre class="describe" v-if="payload.text2[lang].trim().length > 0">{{payload.text2[lang]}}</pre>
        <div v-if="payload.usePage && payload.usePageIds && payload.usePageIds.length" class="usablePages">
          <p>{{locale.message_coupon_usable_pages}}</p>
          <div
            v-for="page in payload.usePageIds"
            :key="page.pageId"
            class="pageList"
             @click="goPage(page.pageId)">
            {{pageSubject(page)}}
            <button type="button" class="btn sizeXs btnRoud">{{locale.shortcuts}}</button>
          </div>
        </div>
        <button v-if="payload.displayBtn" type="button" class="btn btnRound btnFull btnUseCoupon notranslate" @click="useCoupon">{{locale.use_coupon}}</button>
      </div>
      <div v-if="payload.barcode && payload.barcodeValue" class="barcode notranslate">
        <barcode
          :value="payload.barcodeValue"
          :options="barcodeOption" />
        <p class="barcodeValue">{{payload.barcodeValue}}</p>
      </div>
    </div>
    <!-- <div v-if="hasImage" class="downloadCouponImage">
      <button type="button" class="btn btnDownloadCouponImage notranslate" @click="downloadToImage">{{locale.coupon_download_as_image}}</button>
      <div v-if="couponImage" class="downloadCouponImage notranslate" style="display: none;">
        <p class="messageDownload"><span>👇 {{locale.message_download_coupon_image}}</span></p>
        <a :id="`${item.iid}_downloadImage`" :href="couponImage" :download="`coupon_${item.iid}`"><img :src="couponImage"></a>
      </div>
    </div> -->
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import barcode from '@chenfengyuan/vue-barcode'
import domtoimage from 'dom-to-image'

export default {
  name: 'CouponItem',
  props: [
    'lang',
    'item',
    'couponKey',
    'locale'
  ],
  components: {
    barcode
  },
  computed: {
    payload () {
      return typeof (this.item.payload) === 'string' ? JSON.parse(this.item.payload) : this.item.payload
    },
    hasText () {
      return this.payload.text1[this.lang].trim().length > 0 || this.payload.text2[this.lang].trim().length > 0
    },
    hasImage () {
      return this.payload.image !== null
    }
  },
  watch: {
    couponImage (img) {
      setTimeout(() => {
        const link = document.getElementById(`${this.item.iid}_downloadImage`)
        if (link) {
          link.click()
        }
      }, 500)
    }
  },
  data () {
    return {
      couponImage: null,
      isScanning: false,
      barcodeOption: {
        displayValue: false,
        width: 1,
        height: 80,
        margin: 0
      },
      pageIds: null
    }
  },
  methods: {
    isBlank (str) {
      return regExp.replaceAllEmpty(str).length === 0
    },
    downloadToImage () {
      const coupon = this.$refs.printCoupon
      const blobToBase64 = (blob, type) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        return new Promise(resolve => {
          reader.onloadend = () => {
            resolve(reader.result)
          }
        })
      }
      this.isScanning = true
      domtoimage.toBlob(coupon).then((blob) => {
        blobToBase64(blob).then((res) => {
          if (res) {
            this.couponImage = res
            this.isScanning = false
          } else {
            alert(this.locale.alert_download_fail)
          }
        })
      })
    },
    useConfirm () {
      return window.confirm(this.locale.confirm_coupon_staff)
    },
    useCoupon () {
      if (this.useConfirm()) {
        const iid = this.item.iid
        this.$store.dispatch('coupon/useCoupon', { iid: iid, key: this.couponKey }).then((res) => {
          alert(!res ? this.locale.use_coupon_invalid : this.locale.use_coupon_complete)
          this.$store.dispatch('coupon/getCoupon', this.couponKey)
        })
      }
    },
    goPage (pageId) {
      this.$router.push({
        name: 'page',
        params: {
          id: pageId
        }
      })
    },
    pageSubject (page) {
      const lang = this.lang
      const isBlank = this.isBlank
      return page.subject
        ? isBlank(page.subject[lang])
          ? page.title
          : page.subject[lang]
        : page.title || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.downloadCouponImage {
  padding: 15px;
  font-size: 0.85em;
  img {
    margin-top: 10px;
    border: 1px solid $color-lgrey2;
  }
  .btnDownloadCouponImage {
    margin: 0;
    color: $color-grey;
    border: 1px solid $color-lgrey2;
    border-radius: 50px;
    background-color: $color-white;
  }
}
.messageDownload {
  text-align: center;
  > span {
    display: inline-block;
    padding: 8px 10px;
    border-radius: 10px;
    background-color: $bg-default;
  }
}
.btnUseCoupon {
  max-width: calc(100% - 30px);
  margin: 0 15px 15px;
  color: $color-grey;
  border: none;
  background-color: $bg-default;
}
.usablePages {
  margin: 15px;
  padding: 15px;
  font-size: 0.85em;
  text-align: initial;
  background-color: $bg-default;
  .pageList {
    position: relative;
    padding-left: 10px;
    margin-top: 5px;
    &:before {
      content: "·";
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .btn {
    margin-left: 5px;
    color: $color-grey;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
  }
}
</style>
